import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { isAfter, isValid } from 'date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Grid, Box, makeStyles } from '@material-ui/core';
import { KeyboardDatePicker } from '../DatePicker/DatePicker';
const useStyles = makeStyles({
    disableCalendarwrapper: {
        '& .MuiPickersDay-dayDisabled': {
            backgroundColor: 'transparent',
        },
        '& .MuiPickersCalendarHeader-transitionContainer .MuiTypography-root': {
            color: 'rgba(0, 0, 0, 0.38)',
        },
    },
});
export const DateRangePicker = ({ dateRange, onDateRangeChange, isDisabled, locale, inputVariant = 'outlined', margin = 'normal', variant = 'static', labels, ariaLabel, errors = {
    invalidDate: 'Invalid Date Format',
    invalidDateRange: 'Please enter a valid date range',
}, dateRangeTestId = {
    from: 'date-range-picker:from-date',
    to: 'date-range-picker:to-date',
}, }) => {
    const [selectedDateRange, setSelectedDateRange] = useState(dateRange);
    const classes = useStyles();
    useEffect(() => {
        setSelectedDateRange(dateRange);
    }, [dateRange]);
    const disableCalendarProps = {
        shouldDisableDate: () => true,
        // below 2 options are required to disable left and right arrow icons on calendar
        minDate: new Date(),
        maxDate: new Date(),
    };
    const handleDateChange = (filterDate, name) => {
        // below if condition is to prevent onChange action to be triggered when this component is mounted
        if (dateRange.from && dateRange.to) {
            setSelectedDateRange((prevDateRange) => {
                const updatedDateRange = Object.assign(Object.assign({}, prevDateRange), { [name]: filterDate });
                const { from, to } = updatedDateRange;
                if (from && to && isValid(from) && isValid(to) && !isAfter(from, to)) {
                    onDateRangeChange(updatedDateRange);
                }
                return updatedDateRange;
            });
        }
    };
    return (_jsx(MuiPickersUtilsProvider, Object.assign({ locale: locale.dateFnsLocale, utils: DateFnsUtils }, { children: _jsxs(Grid, Object.assign({ container: true, className: isDisabled ? classes.disableCalendarwrapper : '' }, { children: [_jsx(Grid, Object.assign({ item: true, sm: 6 }, { children: _jsxs("div", { children: [_jsx(Box, Object.assign({ mb: 2, px: 2 }, { children: _jsx(KeyboardDatePicker, { inputProps: {
                                        'data-testid': dateRangeTestId.from,
                                        'aria-label': ariaLabel.from,
                                    }, KeyboardButtonProps: {
                                        disabled: true,
                                    }, keyboardIcon: false, label: labels.from, value: selectedDateRange.from || null, fullWidth: true, format: locale.inputDateStyle, onChange: (date) => handleDateChange(date, 'from'), inputVariant: inputVariant, disabled: isDisabled, maxDate: selectedDateRange.to, invalidDateMessage: errors.invalidDate, maxDateMessage: errors.invalidDateRange }, void 0) }), void 0),
                            _jsx(KeyboardDatePicker, Object.assign({ disableToolbar: true, format: locale.inputDateStyle, variant: variant, margin: margin, name: "from", value: selectedDateRange.from, onChange: (date) => handleDateChange(date, 'from') }, (isDisabled && disableCalendarProps)), void 0)] }, void 0) }), void 0),
                _jsx(Grid, Object.assign({ item: true, sm: 6 }, { children: _jsxs("div", { children: [_jsx(Box, Object.assign({ mb: 2, px: 2 }, { children: _jsx(KeyboardDatePicker, { inputProps: {
                                        'data-testid': dateRangeTestId.to,
                                        'aria-label': ariaLabel.to,
                                    }, KeyboardButtonProps: {
                                        disabled: true,
                                    }, keyboardIcon: false, label: labels.to, value: selectedDateRange.to || null, fullWidth: true, format: locale.inputDateStyle, onChange: (date) => handleDateChange(date, 'to'), inputVariant: inputVariant, disabled: isDisabled, minDate: selectedDateRange.from, invalidDateMessage: errors.invalidDate, minDateMessage: errors.invalidDateRange }, void 0) }), void 0),
                            _jsx(KeyboardDatePicker, Object.assign({ disableToolbar: true, format: locale.inputDateStyle, variant: variant, margin: margin, name: "to", value: selectedDateRange.to, onChange: (date) => handleDateChange(date, 'to') }, (isDisabled && disableCalendarProps)), void 0)] }, void 0) }), void 0)] }), void 0) }), void 0));
};
//# sourceMappingURL=DateRangePicker.js.map